import utility from "./utility"

const registration = {
    addressErrorCount: 0,
    manualAddressEntry: false,

    init: function () {
        const registrationForm = document.getElementById("registration--signup-form");
        if (!registrationForm) {
            return;
        }

        const signinButton = document.getElementById("registration--sign-up-sign-in");
        if (signinButton) {
            signinButton.onclick = () => utility.showLoginPopup();
        }

        registrationForm.onsubmit = () => {
            this.requestRegistration();
            return false;
        };

        registrationForm.querySelector("input[name='Email']").onchange = (e) => {
            this.submitRegistrationEmail(e.target.value);
        };

        registrationForm.onkeypress = (e) => {
            var key = e.charCode || e.keyCode || 0;
            if (key === 13) {
                e.preventDefault();
            }
        };

        registrationForm.querySelector("input[name='BirthDate']").oninput = (e) => {
            if (e.currentTarget.value.length === 2) {
                registrationForm.querySelector("input[name='BirthMonth']").focus();
            }
        };

        registrationForm.querySelector("input[name='BirthMonth']").oninput = (e) => {
            if (e.currentTarget.value.length === 2) {
                registrationForm.querySelector("input[name='BirthYear']").focus();
            }
        };

        [...registrationForm.querySelectorAll("input[name='Phone'],input[name='BirthDate'], input[name='BirthMonth'], input[name='BirthYear']")].map(item => {
            item.onkeypress = (e) => {
                if (e.charCode < 48 || e.charCode > 57) {
                    e.preventDefault();
                }
            };
        });

        const addressInput = document.getElementById("registration--signup-location");
        if (addressInput) {
            registration.autoComplete = new window.google.maps.places.Autocomplete(addressInput, { types: ["geocode"] });
            registration.autoComplete.setComponentRestrictions({ "country": ["au", "nz"] });
            registration.autoComplete.setFields(["address_components"]);
            registration.autoComplete.addListener("place_changed", registration.autoCompleteFill);
        }

        const changeAddressForm = document.getElementById("registration--signup-enter-address");
        if (changeAddressForm) {
            changeAddressForm.onclick = () => registration.setManualAddressInput();
        }

        const country = document.querySelector("#registration--signup-address-fields select[name='CountryIso']");
        if (country) {
            country.onchange = () => registration.setRegistrationStateInput();
        }
        registration.setRegistrationStateInput();
    },

    autoCompleteFill() {
        const place = registration.autoComplete.getPlace();
        const container = document.getElementById("registration--signup-address-fields");
        const unitNo = container.querySelector("input[name='UnitNumber']");
        const streetNo = container.querySelector("input[name='StreetNumber']");
        const street = container.querySelector("input[name='Street']");
        const suburb = container.querySelector("input[name='Suburb']");
        const stateOther = container.querySelector("input[name='StateOther']");
        const stateAU = container.querySelector("select[name='StateAU']");
        const postcode = container.querySelector("input[name='PostCode']");
        const country = container.querySelector("select[name='CountryIso']");

        unitNo.value = "";
        streetNo.value = "";
        street.value = "";
        suburb.value = "";
        stateOther.value = "";
        stateAU.value = "";
        postcode.value = "";
        country.value = "";

        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            if (addressType === "subpremise") {
                unitNo.value = place.address_components[i]["short_name"];
            }
            if (addressType === "street_number") {
                streetNo.value = place.address_components[i]["short_name"];
            }
            if (addressType === "route") {
                street.value = place.address_components[i]["long_name"];
            }
            if (addressType === "locality") {
                suburb.value = place.address_components[i]["long_name"];
            }
            if (addressType === "administrative_area_level_1") {
                const stateValue = place.address_components[i]["short_name"];

                // state (other)
                stateOther.value = "N/A";

                // state (AU)
                var selectedStateOption = null;
                [...stateAU.nextElementSibling.querySelectorAll(".select-options > .select-option")].map(option => {
                    if (option.dataset.value === stateValue || selectedStateOption == null) {
                        selectedStateOption = option;
                    }
                });
                const event = document.createEvent('HTMLEvents');
                event.initEvent('click', false, false);
                selectedStateOption.dispatchEvent(event);
            }
            if (addressType === "postal_code") {
                postcode.value = place.address_components[i]["short_name"];
            }
            if (addressType === "country") {
                const iso = place.address_components[i]["short_name"];
                var selectedOption = null;
                [...country.nextElementSibling.querySelectorAll(".select-options > .select-option")].map(option => {
                    if (option.dataset.value === iso || selectedOption == null) {
                        selectedOption = option;
                    }
                });
                const event = document.createEvent('HTMLEvents');
                event.initEvent('click', false, false);
                selectedOption.dispatchEvent(event);
                registration.setRegistrationStateInput();
            }
        }
    },

    setRegistrationStateInput: function () {
        const countrySelector = document.querySelector("#registration--signup-address-fields select[name='CountryIso']");
        if (countrySelector && (countrySelector.value === "" || countrySelector.value === "AU")) {
            document.getElementById("registration--signup-state-other").style.display = "none";
            document.getElementById("registration--signup-state-au").style.display = "";
        }
        else {
            document.getElementById("registration--signup-state-other").style.display = "none";
            document.getElementById("registration--signup-state-au").style.display = "none";
        }
    },

    setManualAddressInput: function() {
        document.getElementById("registration--signup-address-fields").style.display = "";
        document.getElementById("registration--signup-address-autoinput").style.display = "none";
        registration.manualAddressEntry = true;
    },

    submitRegistrationEmail: function (email) {
        utility.ajaxRequest({
            url: "/api/web/account/register-email",
            method: "POST",
            responseType: "text",
            data: "email=" + email,
            success: function (e) {
                var result = JSON.parse(e.target.responseText);
                if (result.resultCode === "NA") {
                    utility.showLoginPopup("NAP", email);
                    // email already in use
                }
                else if (result.resultCode === "ER") {
                    // format error
                    document.getElementById("signup-email-error").innerHTML = "Please enter a valid email address.";
                    document.getElementById("signup-email-error").style.display = "";

                }
                else if (result.resultCode === "OK") {
                    // safe to use
                    document.getElementById("signup-email-error").innerHTML = "";
                    document.getElementById("signup-email-error").style.display = "none";
                }
            }
        });
    },

    requestRegistration: function () {
        const ajaxOptions = {
            url: "/api/web/account/request-signup",
            method: "POST",
            data: utility.getFormData(document.querySelector("#registration--signup-form")),
            success: function (e) {
                var result = JSON.parse(e.target.responseText);
                if (result.resultCode === "S") {
                    registration.handleRegistrationSuccess(result);
                }
                else {
                    utility.enableButton(document.querySelector("#registration--signup-form button[type=submit]"));
                    registration.handleRegistrationError(result);
                }
            },
            error: function () {
                utility.enableButton(document.querySelector("#registration--signup-form button[type=submit]"));
                registration.handleRegistrationError();
            }
        };
        utility.disableButton(document.querySelector("#registration--signup-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    handleRegistrationSuccess: function (result) {
        const redirectToSuccessUrl = () => {
            window.location.href = result.successUrl;
        };

        let dataLayerCompleted = false;
        let brazeCompleted = false;

        const checkAndRedirect = () => {
            if (dataLayerCompleted && brazeCompleted) {
                redirectToSuccessUrl();
            }
        };

        const pushToDataLayer = () => {
            try {
                window.dataLayer.push({
                    event: "Signup",
                    eventCallback: () => {
                        dataLayerCompleted = true;
                        checkAndRedirect();
                    },
                    eventTimeout: 5000
                });
            } catch (error) {
                console.error("DataLayer push failed:", error);
                dataLayerCompleted = true;
                checkAndRedirect();
            }
        };

        const handleBrazeChangeUser = () => {
            try {
                window.braze.changeUser(result.externalId);
                setTimeout(() => {
                    brazeCompleted = true;
                    checkAndRedirect();
                }, 500);
            } catch (error) {
                console.error("Braze changeUser failed:", error);
                brazeCompleted = true;
                checkAndRedirect();
            }
        };

        if (window.dataLayer) {
            pushToDataLayer();
        } else {
            dataLayerCompleted = true;
            checkAndRedirect();
        }

        if (window.braze) {
            handleBrazeChangeUser();
        } else {
            brazeCompleted = true;
            checkAndRedirect();
        }
    },

    handleRegistrationError: function (result) {
        const form = document.getElementById("registration--signup-form");
        const signupError = document.getElementById("registration--signup-form-error");
        if (signupError) {
            signupError.style.display = "inline-block";
        }
        utility.removeFormInputErrors(form);
        if (result && result.resultCode === "F" && result.fieldErrors) {
            result.fieldErrors.map(error => {
                utility.addFormInputError(form, error.Name, error.Error);
                if (error.Name === "Location") {
                    registration.addressErrorCount++;
                    if (registration.addressErrorCount > 2) {
                        registration.setManualAddressInput();
                    }
                }
                if (error.Name === "Email") {
                    const input = form.querySelector("[name='Email']");
                    if (input) {
                        const errorNode = document.getElementById(input.dataset.error);
                        if (errorNode) {
                            const signinLink = errorNode.querySelector(".err-emailexists");
                            if (signinLink) {
                                signinLink.onclick = () => utility.showLoginPopup();
                            }
                        }
                    }
                }
            });
            registration.scrollToRegistrationError(form, result.fieldErrors);
        }
        else {
            let message = result ? result.resultMessage : null;
            let button = null;
            if (!message) {
                message = "We are currently experiencing difficulties in processing your request. Please try again later.<br/><br/>If you continue to experience problems, please contact support@lotteryoffice.com.au.";
                button = {
                    url: window.location.href
                };
            }
            utility.showNotificationPopup({
                title: "Sorry, we are unable to complete your signup",
                content: message,
                button: button
            });
        }
    },

    scrollToRegistrationError: function (form, fieldErrors) {
        const props = [
            "Email", "ConfirmEmail", "Password", "Title", "Firstname", "Surname", "Phone", "BirthDate", "BirthMonth", "BirthYear", "Location", "UnitNumber", "StreetNumber", "Street", "Suburb", "CountryIso", "StateOther", "StateAU", "PostCode", "Confirm"
        ];
        for (let i = 0; i < props.length; i++) {
            const prop = props[i];
            for (let e = 0; e < fieldErrors.length; e++) {
                const errorProp = fieldErrors[e];
                if (prop === errorProp.Name && !(prop === "Location" && registration.manualAddressEntry)) {
                    const element = form.querySelector("[name='" + prop + "']");
                    window.scrollTo({
                        top: utility.getOffset(element).top - 150,
                        behavior: "smooth"
                    });
                    return;
                }
            }
        }
    }
}

export default registration



// WEBPACK FOOTER //
// ./assets/src/js/classes/registration.js